import type Base64InlineImageFile from "../types/Base64InlineImageFile";
import type AttachmentFile from "../types/AttachmentFile";
import type { AttachmentFileList } from "../types/AttachmentFile";

export default function createBase64File(fileList: Base64InlineImageFile[] | null): AttachmentFileList | null {
    if (!fileList) {
        return null;
    }
    
    const localFiles: AttachmentFile[] = [];
    for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        const localFile: AttachmentFile = {
            fileType: file.fileType,
            name: file.name,
            size: file.size,
            type: file.type,
            dataUri: file.dataUri,
        };
        localFiles.push(localFile);
    }
    return localFiles;
}
